import { Search } from "../modules/Search/Search.js";
var search = new Search();
window.search = search;
search.applyEvents();

import { Popup } from "../modules/popup/Popup.js";
var popup = new Popup();
window.popup = popup;

import { Carpass } from "../modules/Carpass/Carpass.js";
var carpass = new Carpass();
window.carpass = carpass;
carpass.applyEvents();

import { Client } from "../modules/Client/Client.js";
var client = new Client();
window.client = client;
client.applyEvents();

$('.text-templates button.btn--text-template').on('click', function (){
	let text = $(this).text();
	let textarea = $(this).closest('.form-item').find('textarea');
	if (textarea.val())
	{
		text = textarea.val() + ' ' + text;
	}
	textarea.val(text);
});

import { News } from "../modules/News/News.js";
var news = new News();
window.news = news;
news.applyEvents();

import { VForm } from "../modules/Catalog/VForm.js";
var vform = new VForm();
window.vform = vform;
vform.applyEvents();

import { CarNumber } from "../modules/CarNumber/CarNumber.js";
var carNumber = new CarNumber();
window.carNumber = carNumber;
carNumber.applyEvents();


// is touch
function isTouchDevice() {
	return (("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

if (isTouchDevice()) {
	$("body").removeClass("des");
	$("body").addClass("mob");
} else {
	$("body").removeClass("mob");
	$("body").addClass("des");
}

if ($('.auth__main').length)
{
	$('.auth__main input[name=auth_login]')[0].focus();
}

$(document).on("click", function (e) {
	if (!(window.matchMedia("(min-width: 768px)").matches) && $(".modules-nav__menu").is(":visible")) {
		var callbackPopup = $(".modules-nav__toggler, .modules-nav__menu");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".modules-nav__menu").fadeOut();
		};
	}

	if ($(".p-plus__overflow").is(":visible") && typeof inst !== 'undefined') {
		var callbackPopup = $(".p-plus__toggle-btn, .p-plus__overflow");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			inst.setOverflowNavOpen(false);
		};
	}

	if ($(".wood-item__actions").is(":visible")) {
		var callbackPopup = $(".wood-item__nav-btn--actions, .wood-item__actions");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".wood-item__nav-btn--actions").removeClass("active");
			$(".wood-item__actions").fadeOut();
		};
	}

	if ($(".header-profile__nav").hasClass("active")) {
		var callbackPopup = $(".header-profile__toggler, .header-profile__nav");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".header-profile__nav").removeClass("active");
		};
	}

	if ($(".form-multi__choice").hasClass("active")) {
		var callbackPopup = $(".form-multi__top-input, .form-multi__result, .form-multi__choice");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".form-multi__top-input").removeClass("active");
			$(".form-multi__choice").removeClass("active");
		};
	}

	if ($(".photos-results__item").hasClass("active")) {
		var callbackPopup = $(".photos-results__item-button--edit, .photos-results__item-popup");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".photos-results__item").removeClass("active");
		};
	}

	if ($(notifications).hasClass("active")) {
		var callbackPopup = $(".notifications__item, .show-notifications, .add-notification");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(notifications).removeClass("active");
		};
	}
});

$(window).on("resize", function () {
	// is touch
	isTouchDevice();

	// modules nav
	if (window.matchMedia("(min-width: 768px)").matches) {
		if ($(".modules-nav__menu").attr('style')) {
			$(".modules-nav__menu").removeAttr("style");
		}
		if ($(".modules-nav__toggler").hasClass("active")) {
			$(".modules-nav__toggler").removeClass("active");
		}
	}

	// tree
	if ($(".tree-toggler").hasClass("active")) {
		$(".tree-toggler").removeClass("active");
		$(".aside").removeClass("active");
		$(".aside-fake").removeClass("active");
	}

	// textarea autoheight
	$(".form-textarea--autoheight").each(function () {
		this.style.height = 'auto';
		this.style.height = (this.scrollHeight) + 2 + 'px';
	});

	// notifications
	notificationsSizes();
});

$('a[href^="#"]').on("click", function () {
	let elementClick = $(this).attr("href").replace(/.*#/, '');
	if (elementClick && $('a[name=' + elementClick + ']').length) {
		let destination = $('a[name=' + elementClick + ']').offset().top
		destination -= $(".header").outerHeight() + ($(".main").innerHeight() - $(".main").height()) / 2;

		console.log(destination);
		$('html, body').animate({ scrollTop: destination }, 1100);
	}
});

$(document).ready(function () {
	if (window.location.hash.match(/#.+/)) {
		let elementClick = window.location.hash.replace(/.*#/, '');
		if (elementClick && $('a[name=' + elementClick + ']').length) {
			let destination = $('a[name=' + elementClick + ']').offset().top
			destination -= $(".header").outerHeight() + ($(".main").innerHeight() - $(".main").height()) / 2;
			$('html, body').scrollTop(destination);
		}
	}
});

$(".tree-toggler").on("click", function () {
	$(this).toggleClass("active");
	$(".aside").toggleClass("active");
	$(".aside-fake").toggleClass("active");
});

$(".header-profile__toggler").on("click", function () {
	$(".header-profile__nav").toggleClass("active");
});

$(".modules-nav__toggler").on("click", function () {
	$(this).toggleClass("active");
	$(".modules-nav__menu").fadeToggle();
});

$(".tree-nav__toggler").on("click", function () {
	$(this).toggleClass("active");
	$(this).closest(".tree-nav__item").toggleClass("active");
	$(this).closest(".tree-nav__item").children(".tree-nav__sublist").slideToggle();
});

// popups
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	$("body").addClass("no-scroll");
	$(".popup[data-popup-name=" + dataPopupName + "]").addClass("active");
});

// priority plus
var inst;
if ($(".js-p-target").length) {
	inst = priorityPlus(document.querySelector('.js-p-target'), {
		innerToggleTemplate: "Ещё",
	});
}

// wood
$("button.wood-item__title").on("click", function (e) {
	$(this).toggleClass("active");
	$(this).closest(".wood-item").toggleClass("active");
	$(this).closest(".wood-item__main").siblings(".wood__sublist").slideToggle();
});

$(".wood-item__nav-btn--actions").on("click", function () {
	$(".wood-item__nav-btn--actions").not(this).removeClass("active");
	$(".wood-item__nav-btn--actions").not(this).closest(".wood-item__nav").siblings(".wood-item__actions").fadeOut();
	$(this).toggleClass("active");
	$(this).closest(".wood-item__nav").siblings(".wood-item__actions").fadeToggle();
});


// tabs
$(".tabs").each(function () {
	let activeTabName = $(this).attr("data-active-tab-name");
	if (activeTabName && activeTabName != "") {
		$(this).find(".tabs__content:first").children(".tabs__tab[data-tab-name!=" + activeTabName + "]").hide();
		$(this).find(".tabs__nav:first").find(".tabs__nav-btn[data-tab-nav-name=" + activeTabName + "]").addClass("active");
	} else {
		$(this).find(".tabs__content:first").children(".tabs__tab:not(:eq(0))").hide();
		$(this).find(".tabs__nav:first").find(".tabs__nav-btn:eq(0)").addClass("active");
	}
});

$(".tabs__nav-btn").on("click", function () {
	if (!$(this).hasClass("active")) {
		let clickedTabNavName = $(this).attr("data-tab-nav-name");
		$(this).parent(".tabs__nav-item").siblings().children(".tabs__nav-btn").removeClass("active");
		$(this).addClass("active");
		$(this).closest(".tabs").find(".tabs__content:first").children(".tabs__tab").hide();
		$(this).closest(".tabs").find(".tabs__content:first").children(".tabs__tab").eq($(this).parent().index()).fadeIn();
		if (clickedTabNavName && clickedTabNavName != "") {
			$(this).closest(".tabs").attr("data-active-tab-name", clickedTabNavName)
		}
	}
});


// loader
function addLoader(loadedElement) {
	$(loadedElement).addClass("_loader");
	$(loadedElement).append("<div class='_loader__container'><div class='_loader__icon'><svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16 2C15.16 2 14.6 2.56 14.6 3.4V6.9C14.6 7.74 15.16 8.3 16 8.3C16.84 8.3 17.4 7.74 17.4 6.9V3.4C17.4 2.56 16.84 2 16 2Z' fill='#002D80'/><path d='M8.57997 10.54C8.85997 10.82 9.27997 10.96 9.55997 10.96C9.83997 10.96 10.26 10.82 10.54 10.54C11.1 9.98002 11.1 9.14002 10.54 8.58002L8.01997 6.06002C7.45997 5.50002 6.61997 5.50002 6.05997 6.06002C5.49997 6.62002 5.49997 7.46002 6.05997 8.02002L8.57997 10.54Z' fill='#002D80'/><path d='M8.3 16C8.3 15.16 7.74 14.6 6.9 14.6H3.4C2.56 14.6 2 15.16 2 16C2 16.84 2.56 17.4 3.4 17.4H6.9C7.6 17.4 8.3 16.84 8.3 16Z' fill='#002D80'/><path d='M8.57993 21.46L6.19993 23.84C5.63993 24.4 5.63993 25.24 6.19993 25.8C6.47993 26.08 6.89993 26.22 7.17993 26.22C7.45993 26.22 7.87993 26.08 8.15993 25.8L10.5399 23.42C11.0999 22.86 11.0999 22.02 10.5399 21.46C9.97993 20.9 9.13993 20.9 8.57993 21.46Z' fill='#002D80'/><path d='M16 23.7C15.16 23.7 14.6 24.26 14.6 25.1V28.6C14.6 29.44 15.16 30 16 30C16.84 30 17.4 29.44 17.4 28.6V25.1C17.4 24.4 16.84 23.7 16 23.7Z' fill='#002D80'/><path d='M23.42 21.46C22.86 20.9 22.02 20.9 21.46 21.46C20.9 22.02 20.9 22.86 21.46 23.42L23.84 25.8C24.12 26.08 24.54 26.22 24.82 26.22C25.1 26.22 25.52 26.08 25.8 25.8C26.36 25.24 26.36 24.4 25.8 23.84L23.42 21.46Z' fill='#002D80'/><path d='M28.6 14.6H25.1C24.26 14.6 23.7 15.16 23.7 16C23.7 16.84 24.26 17.4 25.1 17.4H28.6C29.44 17.4 30 16.84 30 16C30 15.16 29.44 14.6 28.6 14.6Z' fill='#002D80'/><path d='M22.44 10.96C22.86 10.96 23.14 10.82 23.42 10.54L25.8 8.16002C26.36 7.60002 26.36 6.76002 25.8 6.20002C25.24 5.64002 24.4 5.64002 23.84 6.20002L21.46 8.58002C20.9 9.14002 20.9 9.98002 21.46 10.54C21.74 10.82 22.16 10.96 22.44 10.96Z' fill='#002D80'/></svg></div></div>");
}

$("[data-loader-for]").on("click", function () {
	let dataLoaderFor = $(this).attr("data-loader-for");
	addLoader($(dataLoaderFor));
	function removeLoader(loadedElement) {
		$("._loader__container").remove();
		$(loadedElement).removeClass("_loader");
	}
	setTimeout(function () { removeLoader($(dataLoaderFor)) }, 1200);
});

// notifications
const header = $(".header")
const notifications = $(".notifications")
const notificationsList = $(".notifications__list")
function notificationsSizes() {
	let headerHeight = $(header).height();
	$(notificationsList).css("max-height", "calc(100vh - " + headerHeight + "px)");
};
notificationsSizes();

$(".show-notifications").on("click", function () {
	if ($(notifications).hasClass("has-new")) {
		$(notifications).removeClass("has-new");
		$(notifications).addClass("active");
		$(".notifications__item").slideDown();
	} else {
		$(".notifications__item").show();
		$(notifications).toggleClass("active");
	}
});

// var timeoutNotifications = setTimeout(function () {
// 	$(notifications).removeClass("has-new");
// }, 2400);

// $('#subscribe-field').focus(function () {
// 	clearTimeout(timeoutNotifications);
// });

$(".add-notification").on("click", function () {
	if ($(notifications).hasClass("active")) {
		if ($(notifications).hasClass("has-new")) {
			$(notifications).removeClass("has-new");
		}
		$(".notifications__item").slideDown();
		$(notificationsList).prepend(`
			<li class="notifications__item notifications-card">
				<div class="text-block">
					<div class="notifications-card__icon-title">
						<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M7.75392 16C7.75392 15.317 8.30851 14.7633 8.99266 14.7633H14.7613V9.00392C14.7613 8.32089 15.3159 7.76717 16 7.76717C16.6841 7.76717 17.2388 8.32089 17.2388 9.00392V14.7633H23.0075C23.6916 14.7633 24.2463 15.317 24.2463 16C24.2463 16.683 23.6916 17.2367 23.0075 17.2367H17.2388V22.996C17.2388 23.6792 16.6841 24.2327 16 24.2327C15.3159 24.2327 14.7613 23.6792 14.7613 22.996V17.2367H8.99266C8.30851 17.2367 7.75392 16.683 7.75392 16Z" fill="#002D80"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.26484 2.42677C13.3645 1.85774 18.6356 1.85774 23.7351 2.42677C26.7517 2.76337 29.1877 5.13568 29.5427 8.16481C30.1524 13.3705 30.1524 18.6295 29.5427 23.8352C29.1877 26.8644 26.7517 29.2366 23.7351 29.5733C18.6356 30.1422 13.3645 30.1422 8.26484 29.5733C5.24828 29.2366 2.81224 26.8644 2.45738 23.8352C1.84754 18.6295 1.84754 13.3705 2.45738 8.16481C2.81224 5.13568 5.24828 2.76337 8.26484 2.42677ZM23.4599 4.88496C18.5432 4.33632 13.4568 4.33632 8.54002 4.88496C6.64981 5.09586 5.13681 6.58531 4.91811 8.45215C4.33063 13.467 4.33063 18.533 4.91811 23.5479C5.13681 25.4147 6.64981 26.9041 8.54002 27.115C13.4568 27.6636 18.5432 27.6636 23.4599 27.115C25.3502 26.9041 26.8632 25.4147 27.0818 23.5479C27.6693 18.533 27.6693 13.467 27.0818 8.45215C26.8632 6.58531 25.3502 5.09586 23.4599 4.88496Z" fill="#002D80"></path></svg>
						<b>Заголовок с&nbsp;иконкой</b>
					</div>
					<p>Здесь может быть какой-то текст уведомления</p>
					<p><a class="btn btn--l btn--Green" href="#"><span>Перейти куда-то</span></a></p>
				</div>
				<button class="notifications-card__close" type="button" aria-label="закрыть уведомление"></button>
			</li>
		`);
		$(".notifications__item:first-of-type").slideDown();
	} else {
		$(notifications).addClass("has-new");
		$(notificationsList).prepend(`
			<li class="notifications__item notifications-card">
				<div class="text-block">
					<div class="notifications-card__icon-title">
						<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M7.75392 16C7.75392 15.317 8.30851 14.7633 8.99266 14.7633H14.7613V9.00392C14.7613 8.32089 15.3159 7.76717 16 7.76717C16.6841 7.76717 17.2388 8.32089 17.2388 9.00392V14.7633H23.0075C23.6916 14.7633 24.2463 15.317 24.2463 16C24.2463 16.683 23.6916 17.2367 23.0075 17.2367H17.2388V22.996C17.2388 23.6792 16.6841 24.2327 16 24.2327C15.3159 24.2327 14.7613 23.6792 14.7613 22.996V17.2367H8.99266C8.30851 17.2367 7.75392 16.683 7.75392 16Z" fill="#002D80"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.26484 2.42677C13.3645 1.85774 18.6356 1.85774 23.7351 2.42677C26.7517 2.76337 29.1877 5.13568 29.5427 8.16481C30.1524 13.3705 30.1524 18.6295 29.5427 23.8352C29.1877 26.8644 26.7517 29.2366 23.7351 29.5733C18.6356 30.1422 13.3645 30.1422 8.26484 29.5733C5.24828 29.2366 2.81224 26.8644 2.45738 23.8352C1.84754 18.6295 1.84754 13.3705 2.45738 8.16481C2.81224 5.13568 5.24828 2.76337 8.26484 2.42677ZM23.4599 4.88496C18.5432 4.33632 13.4568 4.33632 8.54002 4.88496C6.64981 5.09586 5.13681 6.58531 4.91811 8.45215C4.33063 13.467 4.33063 18.533 4.91811 23.5479C5.13681 25.4147 6.64981 26.9041 8.54002 27.115C13.4568 27.6636 18.5432 27.6636 23.4599 27.115C25.3502 26.9041 26.8632 25.4147 27.0818 23.5479C27.6693 18.533 27.6693 13.467 27.0818 8.45215C26.8632 6.58531 25.3502 5.09586 23.4599 4.88496Z" fill="#002D80"></path></svg>
						<b>Заголовок с&nbsp;иконкой</b>
					</div>
					<p>Здесь может быть какой-то текст уведомления</p>
					<p><a class="btn btn--l btn--Green" href="#"><span>Перейти куда-то</span></a></p>
				</div>
				<button class="notifications-card__close" type="button" aria-label="закрыть уведомление"></button>
			</li>
		`);
		$(".notifications__item:first-of-type").addClass("new").slideDown();
		setTimeout(function () {
			$(notifications).removeClass("has-new");
		}, 2400);
		setTimeout(function () {
			$(".notifications__item").removeClass("new");
		}, 2800);
	}
});

// photo files
$(".photos-results__item-button--edit").on("click", function () {
	$(".photos-results__item-button--edit").not(this).closest(".photos-results__item").removeClass("active");
	$(this).closest(".photos-results__item").toggleClass("active");
});

// table
$(".table__tbody-toggler").on("click", function () {
	$(this).closest(".table__tbody").toggleClass("close");
});

$(".table tbody tr").click(function (e) {
	if ($(this).find('.table__actions-list .table__actions-btn[href*=edit]').length) {
		if ($(e.target).closest('a, input, label').length == 0)
			window.location.href = $(this).find('.table__actions-list .table__actions-btn').attr('href');
	}
})

// all icons
$(".all-icons__item-btn").click(function () {
	var copyText = $(this).attr('data-path');

	var textarea = document.createElement("textarea");
	textarea.textContent = copyText;
	textarea.style.position = "fixed";
	document.body.appendChild(textarea);
	textarea.select();
	document.execCommand("copy");
	document.body.removeChild(textarea);

	$(this).children(".all-icons__item-copied").fadeIn(200).delay(1000).fadeOut(200);
});


// trans admin edits
$(".trans-admin-item__toggler").on("click", function () {
	$(this).closest(".trans-admin-item").find(".trans-admin-item__input").prop('disabled', (i, v) => !v);
	// if ($(this).closest(".trans-admin-item").find(".trans-admin-item__input").prop('disabled', true)) {
	// 	$(this).closest(".trans-admin-item").find(".trans-admin-item__input").prop('disabled', (i, v) => !v);
	// } else {
	// 	$(this).closest(".trans-admin-item").find(".trans-admin-item__input").prop('disabled', true);
	// }
});


// Sortable
const sectionsSortLists = document.querySelectorAll(".sections-sort__list")
if (sectionsSortLists.length > 0) {
	for (let index = 0; index < sectionsSortLists.length; index++) {
		const element = sectionsSortLists[index];
		new Sortable(element, {
			animation: 150,
			ghostClass: "sections-sort__item--ghost",
			chosenClass: "sections-sort__item--chosen",
			dragClass: "sections-sort__item--drag",
			handle: ".sections-sort__item-btn",
		});
	}
}

const sortableTbodies = document.querySelectorAll(".sortable-tbody")
if (sortableTbodies.length > 0) {
	for (let index = 0; index < sortableTbodies.length; index++) {
		const element = sortableTbodies[index];
		new Sortable(element, {
			animation: 150,
			handle: ".sortable-tbody__handle",
		});
	}
}

// Sliders
/*var popupPhotosResultsSlider = new Swiper('.popup-photos-results__slider', {
	slidesPerView: 1,
	navigation: {
		nextEl: '.popup-photos-results__slider-nav-btn--next',
		prevEl: '.popup-photos-results__slider-nav-btn--prev'
	},
	pagination: {
		el: ".popup-photos-results__slider-fraction",
		type: "fraction",
	},
});

$(".photos-results__item-image-wrapper").on("click", function (e) {
	e.preventDefault();
	popupPhotosResultsSlider.slideTo($(this).parent().index(), 0);
});
*/

// Copy element
$(".copy-element__btn").on("click", function (e) {
	e.preventDefault();
	$(this).attr("disabled", true);
	let url = $(this).attr("data-copy-element");
	navigator.clipboard.writeText(url);
	$(this).siblings(".copy-element__copied").addClass("active");
	setTimeout(() => {
		$(this).siblings(".copy-element__copied").removeClass("active");
		$(this).attr("disabled", false);
	}, 2000);
});

import "../modules/Templates/admin-elements";
import { each } from "jquery";

